module.exports = __webpack_public_path__ + "img/bg-2m_791afe6.webp";